import * as React from "react";

export default () => {
  return <div>Ange regler och specifikationer för parkeringsområdet</div>;
};
